import React from 'react';

const SinglePageItemBool = ({ title, value }) => {
  return (
    <div className="single-page-item">
      <h4>
        {title}
      </h4>
      <p>
        {value ? "Yes" : "No"}
      </p>
    </div>
  )
}

export default SinglePageItemBool;